import {useTranslation} from "react-i18next";
import {useLocalStorageNew} from "./useLocalStorageNew";
import {usePPTWebView} from "./usePPTWebView";
import {useSession} from "./useSession";
import {AUDIENCE_RESTRICTION, GRADE_SCHEMA, INTEGRATION_TYPES, POLL_TYPE, SYNC_LMS_OPTIONS} from "../utils/constants";
import {getShortName, removePrefixNew} from "../utils/helpers";
import {useConfig} from "./useConfig";

export const useSynLMSConfiguration = (activity={}) => {
    const { t } = useTranslation();
    const [, getInstitution] = useLocalStorageNew(window.location.hostname, {});
    const {isPPTPage, parseToken} = usePPTWebView();
    const {parseSessionToken, getSession} = useSession();
    const config = useConfig();

    let institution = getInstitution();
    let tokenObj = isPPTPage() ? parseToken() : parseSessionToken();
    let sessionObj = isPPTPage() ? {} : getSession();
    const {courseId=""} = sessionObj;

    const {pollType, gradeSchema, syncLms, syncLmsOption, lmsHomeUrl, lmsRedirectUrl} = activity;
    const getDefaultConfiguration = (courseOptions=[]) => {
        let {ssoConfig={}} = institution;
        let integrationType = getIntegrationType();



        let settings = {};
        courseOptions = !!courseOptions ? courseOptions : []
        courseOptions = courseOptions.filter(c => !!c.isLmsCourse);

        let newCourseId = !!courseId ? courseOptions.find(c => c.value === courseId)?.value : undefined;

        newCourseId = !!newCourseId
            ? newCourseId
            : (!!courseOptions.length ? courseOptions[0]?.value : null);


        if (!!integrationType) {
            settings.syncLms = true;
            settings.audienceRestriction = AUDIENCE_RESTRICTION.REGISTERED;
            if (!!newCourseId
                // && integrationType !== INTEGRATION_TYPES.MOODLE
                && ssoConfig.hasOwnProperty(integrationType)
                && Object.keys(JSON.parse(ssoConfig[integrationType])).length > 1
                && JSON.parse(ssoConfig[integrationType]).hasOwnProperty("lmsApiLink")
            ) {
                settings.syncLmsOption = SYNC_LMS_OPTIONS.LMS_API_SYNC;
                settings.courseId = newCourseId;
            } else {
                settings.syncLmsOption = SYNC_LMS_OPTIONS.EMBEDDED;
            }

        } else {
            settings.syncLms = false;
        }

        return settings;
    }
    const isLMS = () => {
        return !!getIntegrationType();
    }

    const getIntegrationType = () => {
        const {intType="", idpType="", lmsType=""} = tokenObj;

        let integrationType = "";
        if (idpType === "LMS") {
            integrationType = intType;
        } else if (idpType === "SAML" && !!lmsType) {
            integrationType = lmsType;
        }


        return integrationType;
    }

    const isAPISyncOptionAvailable = () => {

        let {ssoConfig={}} = institution;
        const {intType="", idpType="", lmsType=""} = tokenObj;

        let integrationType = "";
        if (idpType === "LMS") {
            integrationType = intType;
        } else if (idpType === "SAML" && !!lmsType) {
            integrationType = lmsType;
        }

        if (!integrationType) {
            return false;
        }

        return ssoConfig.hasOwnProperty(integrationType)
            && Object.keys(JSON.parse(ssoConfig[integrationType])).length > 1
            && JSON.parse(ssoConfig[integrationType]).hasOwnProperty("lmsApiLink");
    }

    const isAlreadyEmbedded = () => {
        if (!syncLms) {
            return false;
        }

        if (syncLmsOption === SYNC_LMS_OPTIONS.EMBEDDED && !!lmsHomeUrl) {
            return true;
        }

        if (syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC && !!lmsRedirectUrl) {
            return true;
        }


        return false;
    }

    const isUnfinishedEmbedded = () => {
        return syncLms && syncLmsOption === SYNC_LMS_OPTIONS.EMBEDDED && !lmsHomeUrl;
        // return syncLms && !lmsHomeUrl;
    }


    const correctConfigurations = (activityToAdd) => {
        //if it's ungraded poll
        if (activityToAdd.pollType === POLL_TYPE.MERGED_POLL && activityToAdd.gradeSchema === GRADE_SCHEMA.UNGRADED.key) {
            activityToAdd.syncLms = false;
        }

        //if disable syncLms
        if (!activityToAdd.syncLms) {
            delete activityToAdd.syncLmsOption;
        }


        //if audienceRestriction is not equal to registered
        if (activityToAdd.audienceRestriction !== AUDIENCE_RESTRICTION.REGISTERED) {
            delete activityToAdd.courseId;
        }

        //
        // //if activity has course ID
        // if (!!activityToAdd.courseId || (activityToAdd.syncLms && !!activityToAdd.syncLmsOption)) {
        //     activityToAdd.audienceRestriction = AUDIENCE_RESTRICTION.REGISTERED;
        // }




        //if choose embed activity and hasn't been embedded yet
        if (activityToAdd.syncLmsOption === SYNC_LMS_OPTIONS.EMBEDDED && !activityToAdd.lmsHomeUrl) {
            delete activityToAdd.courseId;
        }


        return activityToAdd;
    }

    const verifyConfiguration = (activity) => {
       if (!activity.hasOwnProperty("syncLms") || (!!activity.syncLms && !activity.syncLmsOption)) {
            return t("gradebook.syncOptionMissingError");
       }

        if (activity.syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC && !activity.courseId) {
            return t("gradebook.courseMissingError");
        }


        if (activity.syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC) {
            let integrationType = getIntegrationType();
            if (integrationType === INTEGRATION_TYPES.D2L && (!activity.D2LModuleId || "-1" === activity.D2LModuleId)) {
                return t("gradebook.d2lModuleMissingError");
            }

            if (integrationType === INTEGRATION_TYPES.MOODLE && (!activity.moodleSectionId || "-1" === activity.moodleSectionId)) {
                return t("gradebook.moodleSectionMissingError");
            }

        }

       return "";
    }


    const verifyConfigurationBeforeAddingQuestion = (activity) => {
        if (!activity.hasOwnProperty("syncLms") || (!!activity.syncLms && !activity.syncLmsOption)) {
            return t("activity.syncOptionMissingBeforeAddingQuestion");
        }

        if (activity.syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC && !activity.courseId) {
            return t("activity.courseMissingBeforeAddingQuestion");
        }


        if (activity.syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC) {
            let integrationType = getIntegrationType();
            //add LMSColumnId for backward compatible
            if (integrationType === INTEGRATION_TYPES.D2L && !activity.LMSColumnId && (!activity.D2LModuleId || "-1" === activity.D2LModuleId)) {
                return t("activity.moduleMissingBeforeAddingQuestion");
            }

        }

        return "";
    }

    const verifyConfigurationBeforeSaving = (activity) => {
        if (!activity.hasOwnProperty("syncLms") || (!!activity.syncLms && !activity.syncLmsOption)) {
            return t("activity.syncOptionMissingBeforeAddingQuestion");
        }

        if (activity.syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC && !activity.courseId) {
            return t("activity.courseMissingBeforeSaving");
        }


        if (activity.syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC) {
            let integrationType = getIntegrationType();
            //add LMSColumnId for backward compatible
            if (integrationType === INTEGRATION_TYPES.D2L && !activity.LMSColumnId && (!activity.D2LModuleId || "-1" === activity.D2LModuleId)) {
                return t("activity.moduleMissingBeforeSaving");
            }

        }

        return "";
    }


    const getRedirectUrl = (poll) => {
        const {syncLms=false, lmsRedirectUrl="", sk, LMSColumnId} = poll;
        let pollCode = removePrefixNew(sk);

        let shortName = getShortName();
        const INST_URL = shortName + '.' + config.host_url;
        if (!syncLms) {
            return `${INST_URL}/qr/${pollCode}`;
        } else {
            if (lmsRedirectUrl) {
                return lmsRedirectUrl;
            }

            if (!!LMSColumnId) {
                return `${INST_URL}/qr/${pollCode}`;
            }

            return "";
        }
    }


    const canHavePollCode = (poll) => {
        const {syncLms=false, LMSColumnId} = poll;

        if (!syncLms) {
            return true;
        } else if (!!LMSColumnId) {
            return true;
        } else {
            return false;
        }
    }



    /**
     * Mirrors the backend embedByAPI check: only an API-synced activity that has no LMS column yet gets embedded,
     * and only then does the slide get a (new) QR code.
     */
    const needsLMSEmbedding = (poll = {}) => {
        const {syncLms=false, syncLmsOption, LMSColumnId} = poll;
        return !!syncLms && syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC && !LMSColumnId;
    }


    return {
        getDefaultConfiguration,
        isLMS,
        getIntegrationType,
        isAPISyncOptionAvailable,
        isUnfinishedEmbedded,
        isAlreadyEmbedded,
        correctConfigurations,
        verifyConfiguration,
        verifyConfigurationBeforeAddingQuestion,
        verifyConfigurationBeforeSaving,
        getRedirectUrl,
        canHavePollCode,
        needsLMSEmbedding
    };
}